import { Component, Input } from '@angular/core';
// services
import { TranslateService } from '@ngx-translate/core';
import { ProfileCollectionFacade } from '@app/profile/components/profile-collection/profile-collection-reactive-store';

@Component({
  selector: 'dgx-profile-collection-search',
  templateUrl: './profile-collection-search.component.html',
})
export class ProfileCollectionSearch {
  @Input() public searchTerm: string = '';

  public i18n = this.translateService.instant(['Core_Search']);

  constructor(
    private translateService: TranslateService,
    private profileCollectionFacade: ProfileCollectionFacade
  ) {}

  public onSearchSubmit(term: string): void {
    this.profileCollectionFacade.searchItems(term);
  }
}
